import { render, staticRenderFns } from "./AthletePerformance.vue?vue&type=template&id=25cb9fb3"
import script from "./AthletePerformance.vue?vue&type=script&lang=js"
export * from "./AthletePerformance.vue?vue&type=script&lang=js"
import style0 from "./AthletePerformance.vue?vue&type=style&index=0&id=25cb9fb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports